var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-layout',{attrs:{"wrap":""}},[(_vm.value === null)?_c('fp-loader'):_c('v-flex',[_c('land-of-work-form',{attrs:{"user-lands-data":_vm.value},on:{"update:userLandsData":function($event){_vm.value=$event},"update:user-lands-data":function($event){_vm.value=$event}}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }